import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";

import PreviewPage from "../../Components/Preview/PreviewPage2";
import * as actionCreator from "../../Store/actions/index";
import Spinner from "../../Components/UI/Spinner/Spinner";

class Preview extends Component {
  draftId = localStorage.getItem("draftId");

  componentDidMount() {
    // this.props.onGetDraftPost(236)
    if (this.draftId) {
      this.props.onGetDraftPost(this.draftId);
    }
  }

  componentDidUpdate(prevProp) {
    if (prevProp.draftPostId !== this.props.draftPostId) {
      if (this.draftId & (this.draftId === this.props.draftPostId)) {
        this.props.onGetDraftPost(this.draftId);
      } else {
        this.draftId = this.props.draftPostId;
        this.props.onGetDraftPost(this.props.draftPostId);
      }
    } else if (prevProp.serviceDraftId !== this.props.serviceDraftId) {
      if (this.draftId & (this.draftId === this.props.serviceDraftId)) {
        this.props.onGetDraftPost(this.draftId);
      } else {
        this.draftId = this.props.serviceDraftId;
        this.props.onGetDraftPost(this.props.serviceDraftId);
      }
    }
  }

  submitPostHandler = () => {
    if (this.draftId) {
      this.props.onSendPostSubimt(this.draftId);
    } else {
      this.props.onSendPostSubimt(this.props.draftPostId);
    }
    this.props.history.push("/");
  };

  editPostHandler = () => {
    if (this.draftId) {
      this.props.onGetPostToEdit(this.draftId);
    } else {
      this.props.onGetPostToEdit(this.props.draftPostId);
      // this.props.onGetPostToEdit(231)
    }
    this.props.history.push("/Edit");
  };

  render() {
    let noEdit = false,
      service = false;
    if (this.props.location.state) {
      if (this.props.location.state.prevPath === "/Activites") {
        noEdit = true;
      }
      if (this.props.location.state.service) {
        service = true;
      }
    }
    return (
      <Fragment>
        {this.props.loadingPreview ||
        this.props.sendingPostToDraft ||
        this.props.postingService ? (
          <div style={{ width: "300px", margin: "0 auto" }}>
            <Spinner />
          </div>
        ) : this.props.previewPost && !this.props.loadingPutEdit ? (
          <PreviewPage
            post={this.props.previewPost}
            submitPost={this.submitPostHandler}
            editPost={this.editPostHandler}
            noEdit={noEdit}
            service={service}
          />
        ) : this.props.loadingPutEdit ? (
          <div style={{ width: "300px", margin: "0 auto" }}>
            <h1>UPLOADING</h1>
            <Spinner />
          </div>
        ) : (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              height: "50vh",
            }}
          >
            <p className="m-0">
              Please select a post to view
              <span>
                <Button
                  variant="link"
                  className="p-0 ms-2"
                  onClick={() => this.props.history.push("/Activites")}
                >
                  Go to Activites
                </Button>
              </span>
            </p>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loadingPreview: state.Preview.loadingPreview,
    previewPost: state.Preview.previewPost,
    error: state.Preview.error,
    // draft Req:
    sendingPostToDraft: state.Landing.sendingPostToDraft,
    draftPostId: state.Landing.draftPostId,
    // service Draft ID:
    postingService: state.AddService.postingService,
    serviceDraftId: state.AddService.draftServiceId,
    // Edit put Req:
    loadingPutEdit: state.EditPost.loadingPutEdit,
    EditedPost: state.EditPost.EditedPost,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetDraftPost: (postId) => {
      dispatch(actionCreator.getPreviewPost(postId));
    },
    onSendPostSubimt: (postId) => {
      dispatch(actionCreator.sendPostSubmit(postId));
    },
    onGetPostToEdit: (postId) => {
      dispatch(actionCreator.getEditPost(postId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
